/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Service_AriaInputs */

const en_form_service_aria = /** @type {(inputs: Form_Service_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a service`)
};

const ar_form_service_aria = /** @type {(inputs: Form_Service_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر خدمة`)
};

const bn_form_service_aria = /** @type {(inputs: Form_Service_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একটি সেবা বেছে নিন`)
};

const de_form_service_aria = /** @type {(inputs: Form_Service_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistung auswählen`)
};

const es_form_service_aria = /** @type {(inputs: Form_Service_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar un servicio`)
};

const fr_form_service_aria = /** @type {(inputs: Form_Service_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner un service`)
};

const pt_form_service_aria = /** @type {(inputs: Form_Service_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar um serviço`)
};

const zh_form_service_aria = /** @type {(inputs: Form_Service_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一项服务`)
};

const tr_form_service_aria = /** @type {(inputs: Form_Service_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet seç`)
};

const ru_form_service_aria = /** @type {(inputs: Form_Service_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбери услугу`)
};

const pl_form_service_aria = /** @type {(inputs: Form_Service_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz usługę`)
};

/**
* | output |
* | --- |
* | "Select a service" |
*
* @param {Form_Service_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_service_aria = /** @type {((inputs?: Form_Service_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Service_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_service_aria(inputs)
	if (locale === "bn") return bn_form_service_aria(inputs)
	if (locale === "de") return de_form_service_aria(inputs)
	if (locale === "es") return es_form_service_aria(inputs)
	if (locale === "fr") return fr_form_service_aria(inputs)
	if (locale === "pt") return pt_form_service_aria(inputs)
	if (locale === "zh") return zh_form_service_aria(inputs)
	if (locale === "tr") return tr_form_service_aria(inputs)
	if (locale === "ru") return ru_form_service_aria(inputs)
	if (locale === "pl") return pl_form_service_aria(inputs)
	return en_form_service_aria(inputs)
});